// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-02
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./PanelSection.module.scss";

// Wrapper for most sections in the Remote Operation Panel.
export default function PanelSection(props: Props): Component {
  return (
    <div className="container">
      <label className={styles.controlLabel}>{props.label}</label>
      <div className="row align-items-center">{props.children}</div>
    </div>
  );
}

PanelSection.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.any,
};

interface Props {
  label: string;
  children?: Children;
}
